import { FunctionComponent } from "react";
import { Box, Heading, Stack, Text } from "@chakra-ui/react";

import { ReactComponent as FraudDetection } from "src/assets/images/fraud_detection_icon.svg";
import { ReactComponent as AmlScreening } from "src/assets/images/aml_screening_icon.svg";
import { ReactComponent as OnboardingScreening } from "src/assets/images/onboarding_screening.svg";
import { ReactComponent as KycChecks } from "src/assets/images/kyc_checks.svg";
import { ReactComponent as Watchlist } from "src/assets/images/watchlist.svg";
import { ReactComponent as RiskManagement } from "src/assets/images/risk_management.svg";
import { ReactComponent as Compliance } from "src/assets/images/compliance.svg";

const Trending: FunctionComponent = () => {
  return (
    <Box
      bg={"#003366"}
      borderRadius={"8px"}
      textAlign={"center"}
      color={"white"}
      padding={"48px 0px"}
      boxShadow="0px 0px 4px 0px #3235CF24"
    >
      <Heading as={"h4"} fontSize={"30px"} color={"#fff"}>
        What's trending on IDRadar?
      </Heading>
      <Text mt={3} mb={10} color={"#fff"} fontWeight={300} fontSize={"15px"}>
        Dive into the world of endless possiblities with Radar features
      </Text>
      <Stack
        direction={"row"}
        alignItems={"center"}
        justifyContent={"center"}
        gap={8}
      >
        <FraudDetection />
        <AmlScreening />
        <OnboardingScreening />
        <KycChecks />
        <Watchlist />
        <RiskManagement />
        <Compliance />
      </Stack>
    </Box>
  );
};

export default Trending;
